require("prismjs/themes/prism-okaidia.css");

// handle collapsing
// require("./src/scripts/collapse.js");
require("./src/scripts/collapse.css");